<template>
  <v-row class="text--primary">
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Produtos
        </v-subheader>
        <v-divider/>
        <px-aprovacao-solicitacao-produtos-table :aprovacao="aprovacao"
                                                 @update="emitUpdate"
                                                 show-estoque/>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import AprovacaoSolicitacaoProdutosTable
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoProdutosTable.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoSolicitacaoProdutosTable: AprovacaoSolicitacaoProdutosTable,
  },
};
</script>
